import { Component, Injector, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { COMMON_MODULES } from '@src/app/core/constants/common-module.constant';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { IMAGES_URL } from '@src/app/core/constants/system-list.constant';
import { SharedDataService } from '@src/app/core/services';
import { ALL_SERVICES, PLUS_MEMBERSHIP, ROUTES } from '@src/app/core/constants';
import { CoreClass } from '@src/app/core/base/core.class';
import { environment } from '@src/environments/environment'; 
import { MiniEnvInfoCardComponent } from '@src/app/core/shared/components/ui/cardbox/mini-env-info-card/mini-env-info-card.component';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvBannerComponent } from "@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component";
import { MiniEnvFooterComponent } from '../../layout/mini-env/footer/footer.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MembershipPlanComponent } from '@src/app/core/shared/components/membership-plan/membership-plan.component';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import * as faqsJson from '@src/assets/i18n/everydaycare/en.json'; 
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import { MiniEnvBenefitCardsComponent } from "@src/app/core/shared/components/mini-env/mini-env-benefit-cards/mini-env-benefit-cards.component";

declare var $: any;

@Component({
  selector: 'app-einstein',
  templateUrl: './einstein.component.html',
  styleUrls: ['./einstein.component.scss'],
  preserveWhitespaces: true,
  standalone: true,
  imports: [
    ...COMMON_MODULES,
    HeadingBlockOneModule,
    IconboxOneModule,
    IconboxTwoModule,
    HeadingBlockFullWidthModule,
    ImageboxOneModule,
    ImageboxFullwidthModule,
    CardboxOneModule,
    BannerOneModule,
    MiniEnvInfoCardComponent,
    ImageboxBulletScrollComponent,
    MiniEnvHeadingBlockComponent,
    MiniEnvFaqsComponent,
    MiniEnvBannerComponent,
    MiniEnvSubFooterComponent,
    MembershipPlanModule,
    VideoPlayerComponent,
    MiniEnvBenefitCardsComponent
]
})
export class EinsteinComponent extends CoreClass implements OnInit {
  testimonials: any = [];
  blogs: any = [];
  IMAGES_URL: string = IMAGES_URL;
  faqList = faqsJson.FAQS.FAQ_LIST;

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient
  ) {
    super(injector);
    this.setMiniEnvValues();
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipPlanCode = 'WOW_PLUS_MEMBERSHIP';

  services = [
    {
      id: '01',
      title: 'Urgent Care',
      description: '24/7 available virtual urgent care for non-life-threatening situations.',
      icon: 'siren 1.png', 
      isFree: true,
      link: ROUTES.virtualUrgentCare
    },
    {
      id: '02',
      title: 'Mental Health Counseling',
      description: 'Mental health support with certified mental health specialists.',
      icon: 'mental-health 1.png',
      isFree: true,
      link: ROUTES.mentalHealth
    },
    {
      id: '03',
      title: 'Medications',
      description: 'Free generics, with discounts on brand-name prescriptions.',
      icon: 'medicine (2) 1.png',
      isFree: true,
      link: ROUTES.pharmacy
    },
    {
      id: '04',
      title: 'Imaging',
      description: 'Clear, transparent, and discounted rates at 4,000+ labs nationwide.',
      icon: 'mri-machine 1.png',
      isFree: false,
      link: ROUTES.imaging
    },
    {
      id: '05',
      title: 'Office Visits',
      description: 'Save up to 35% with 350k+ doctors nationwide.',
      icon: 'hospital (1) 1.png',
      isFree: false,
      link: ROUTES.officeVisit
    },
    {
      id: '05',
      title: 'Lab Tests',
      description: 'Save up to 60% at 2,100+ lab locations.',
      icon: 'test-tube 1.png',
      isFree: false,
      link: ROUTES.labTest
    },
    {
      id: '05',
      title: 'Procedures',
      description: 'Save 50%+ on procedures at 5,000+ surgery centers.',
      icon: 'robotic-surgery 1.png',
      isFree: false,
      link: ROUTES.surgical
    }
  ];

  faqs: any[] = [
  {
    question: 'What is the difference between WoW Plus & health insurance?',
    answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
  },
  {
    question: 'Why do I need WoW Health?',
    answer: 'It provides affordable access to routine care and prescriptions...'
  }
];

bannerSlides: any[] = [
  {
    title: 'Insurance Doesn’t Give You the Benefits We Do',
    subtitle: 'Einstein Bros. Bagels has partnered with WoW Health to bring healthcare benefits for its employees. With insurance, after having paid hefty monthly premiums, you still have to pay copays, deductibles, and coinsurances. When you add it all up, the out-of-pocket expense is more than with our WoW Health directpay providers who disclose the total cost of care, and you pay it at the time of service.',
    discription: 'That is why WoW Health isn\'t insurance – its an affordable membership that puts YOU in control.',
    buttonText: 'View Plans',
    bgImageUrl: 'assets/tenant-assets/mini-env/images/einstein-bagle-banner.png',
    bannerClass: 'einstein-banner',
    link: '/join'
  },
  {
    title: 'Insurance Doesn’t Give You the Benefits We Do',
    subtitle: 'Einstein Bros. Bagels has partnered with WoW Health to bring healthcare benefits for its employees. With insurance, after having paid hefty monthly premiums, you still have to pay copays, deductibles, and coinsurances. When you add it all up, the out-of-pocket expense is more than with our WoW Health directpay providers who disclose the total cost of care, and you pay it at the time of service.',
    discription: 'That is why WoW Health isn\'t insurance – its an affordable membership that puts YOU in control.',
    buttonText: 'View Plans',
    bgImageUrl: 'assets/tenant-assets/mini-env/images/einstein-bagle-banner.png',
    bannerClass: 'einstein-banner',
    link: '/join'
  },
];

  ngOnInit(): void {
    // this.getTestimonials();
    // this.getBlogs();
    this.sharedService.removeNavbarLinks = false;

    // this.activatedRoute.params.subscribe((data: any) => {
    //   console.log(data); // Access the extra parameter value
    //   // this.language = data.language
    // });
  }
  getTestimonials() {
    // this code need improvement
    const apiUrl = `/assets/tenant-assets/testimonials/en.json`;
    this.httpClient.get(apiUrl).subscribe((data: any) => {
      this.testimonials = data; // Assign the data to the property
    });
  }
  getBlogs() {
    // this code need improvement
    const apiUrl = `/assets/tenant-assets/blogs/en.json`;
    this.httpClient.get(apiUrl).subscribe((data: any) => {
      this.blogs = data; // Assign the data to the property
    });
  }

  buttonAction() {
    
    const section = document.getElementById('membership-section');

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setMiniEnvValues() {
    this.httpService.requestEntity('GET', `assets/tenant-assets/mini-env/${environment.miniEnvFile}`).subscribe((res: any) => {   
      const miniEnvConfig = res?.body;  
      if (miniEnvConfig) {
        this.membershipPlanCode = miniEnvConfig['pegasus-einstein'].membershipPlanTypes;
      }
    })
  }

onSliderBtnAction() {
    this.buttonAction();
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

}
